import React from 'react';
import { m as motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { heroTestimonial } from '../data/testimonials';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TestimonialHighlight() {
  return <section className="bg-mp-dark py-14 md:py-20" data-id="element-196" data-mp="18us4tz8s0bk2">
      <Container data-id="element-197" data-mp="18rcpqwf3r2in">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto max-w-[700px] rounded-2xl border border-mp-lime/30 bg-mp-card p-8 text-center md:p-10" data-id="element-198" data-mp="1dt1z87mof84m">
          <div className="flex items-center justify-center gap-0.5" aria-hidden="true" data-id="element-199" data-mp="1rix7129sbogr">
            {Array.from({
            length: 5
          }).map((_, idx) => <StarIcon key={idx} className="h-4 w-4 fill-mp-lime text-mp-lime" data-id="element-200" data-mp="21ieare5h7sa3" data-mpi={idx} />)}
          </div>
          <p className="mt-5 text-lg leading-relaxed text-mp-white md:text-xl" data-id="element-201" data-mp="2yvjokc2fm1ur">"{heroTestimonial.quote}"</p>
          <p className="mt-5 text-sm text-mp-gray" data-id="element-202" data-mp="2tvffv87rmbf3">
            — {heroTestimonial.author}, {heroTestimonial.role} ({heroTestimonial.location})
          </p>
        </motion.div>
      </Container>
    </section>;
}